import { useSelector } from "react-redux";
import { Navigate, Outlet } from "react-router-dom";

export function deriveRole(MgCd) {
  if (!MgCd) return null;
  if (MgCd === "A") return "Admin";
  if (MgCd.length === 7) return "MR";
  if (MgCd.length >= 2 && MgCd.length <= 6) return "AM";
  return null;
}

const RoleBasedRoute = ({ allowedRoles }) => {
  const { user } = useSelector((state) => state.auth);
  const role = deriveRole(user?.role);

  if (!role || !allowedRoles.includes(role)) {
    if (role === "MR") return <Navigate to="/mr/dashboard" replace />;
    if (role === "AM") return <Navigate to="/am/dashboard" replace />;
    if (role === "Admin") return <Navigate to="/admin/dashboard" replace />;
    return <Navigate to="/login" replace />;
  }

  return <Outlet />;
};

export default RoleBasedRoute;
